module.exports = __webpack_public_path__ + "static/img/EMMANUEL_GARCIA.16cc0bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/EMMANUEL_GARCIA.jpg
// module id = 3npI
// module chunks = 1